<template>
	<popup :title="`${$LanguageHelper.translate('_TITLE_HOW_TO_INSTALL_ON_IOS_')}`" :opened="opened" @mounted="opened=true" @close="$emit('close')">
		<div class="pageContent" v-if="render">
			<f7-card>
				<f7-card-content class="customContent">
					<div v-html="$LanguageHelper.translate('_CONTENT_HOW_TO_INSTALL_ON_IOS_')" />
				</f7-card-content>

				<div class="wrapperVideo">
					<video controls>
						<source src="/static/how-to-install-on-ios.mp4" type="video/mp4">
						</video>
					</div>
			</f7-card>
		</div>
	</popup>
</template>

<script>
import Popup from '../components/smart/popup.vue';

export default {
	components: {
    'popup': Popup,
	},

	data() {
    return {
			render: false,
			opened: false,
		};
  },

	methods: {},

	created() {
		this.render = true;
	}
};
</script>

<style scoped>
.wrapperVideo {
	position: relative;
	width: 100%;
	padding-bottom: 56.25%; /* 16:9 aspect ratio (9/16 = 0.5625 -> 56.25%) */
	height: 0;
	margin: auto;
	overflow: hidden;
}

video {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}

.customContent {
	padding-top:2px!important;
}
</style>

<style>
.customContent ul {
	list-style-position: outside;
	padding-left: 10px;
}
</style>
